import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=2a4a1a28&scoped=true&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"
import style0 from "./Payment.vue?vue&type=style&index=0&id=2a4a1a28&lang=scss&scoped=true&"
import style1 from "./Payment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a1a28",
  null
  
)

export default component.exports